var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 211,
    viewBox: "0 0 181 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5594 198.411C140.217 198.411 180.472 158.156 180.472 108.498C180.472 58.8411 140.217 18.5859 90.5594 18.5859C40.9019 18.5859 0.646484 58.8411 0.646484 108.498C0.646484 158.156 40.9019 198.411 90.5594 198.411Z",
    fill: "url(#paint0_linear_14069_18819)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14069_18819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.112 70.1348H39.0114C35.7009 70.1348 33.0172 72.8184 33.0172 76.1289V202.006C33.0172 205.317 35.7009 208.001 39.0114 208.001H142.112C145.422 208.001 148.106 205.317 148.106 202.006V76.1289C148.106 72.8184 145.422 70.1348 142.112 70.1348Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5704 88.1182H47.4006C45.4143 88.1182 43.8041 89.7284 43.8041 91.7147C43.8041 93.701 45.4143 95.3112 47.4006 95.3112H78.5704C80.5567 95.3112 82.1669 93.701 82.1669 91.7147C82.1669 89.7284 80.5567 88.1182 78.5704 88.1182Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.15 103.702H47.4007C45.4144 103.702 43.8042 105.312 43.8042 107.299C43.8042 109.285 45.4144 110.895 47.4007 110.895H100.15C102.136 110.895 103.746 109.285 103.746 107.299C103.746 105.312 102.136 103.702 100.15 103.702Z",
    fill: "#BBBBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5704 120.487H47.4006C45.4143 120.487 43.8041 122.098 43.8041 124.084C43.8041 126.07 45.4143 127.68 47.4006 127.68H78.5704C80.5567 127.68 82.1669 126.07 82.1669 124.084C82.1669 122.098 80.5567 120.487 78.5704 120.487Z",
    fill: "#BBBBBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.15 136.073H47.4007C45.4144 136.073 43.8042 137.683 43.8042 139.67C43.8042 141.656 45.4144 143.266 47.4007 143.266H100.15C102.136 143.266 103.746 141.656 103.746 139.67C103.746 137.683 102.136 136.073 100.15 136.073Z",
    fill: "#BBBBBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5705 152.856H47.4007C45.4144 152.856 43.8042 154.467 43.8042 156.453C43.8042 158.439 45.4144 160.049 47.4007 160.049H78.5705C80.5568 160.049 82.1671 158.439 82.1671 156.453C82.1671 154.467 80.5568 152.856 78.5705 152.856Z",
    fill: "#BBBBBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.15 168.442H47.4008C45.4145 168.442 43.8043 170.053 43.8043 172.039C43.8043 174.025 45.4145 175.635 47.4008 175.635H100.15C102.136 175.635 103.746 174.025 103.746 172.039C103.746 170.053 102.136 168.442 100.15 168.442Z",
    fill: "#BBBBBB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14069_18819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.111 9H39.0108C35.7003 9 33.0166 11.6837 33.0166 14.9942V50.9592C33.0166 54.2697 35.7003 56.9533 39.0108 56.9533H142.111C145.421 56.9533 148.105 54.2697 148.105 50.9592V14.9942C148.105 11.6837 145.421 9 142.111 9Z",
    fill: "#828282"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5698 22.1885H47.4C45.4137 22.1885 43.8035 23.7987 43.8035 25.785C43.8035 27.7713 45.4137 29.3815 47.4 29.3815H78.5698C80.5561 29.3815 82.1663 27.7713 82.1663 25.785C82.1663 23.7987 80.5561 22.1885 78.5698 22.1885Z",
    fill: "#BBBBBB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.149 37.7725H47.4001C45.4138 37.7725 43.8036 39.3827 43.8036 41.369C43.8036 43.3553 45.4138 44.9655 47.4001 44.9655H100.149C102.135 44.9655 103.746 43.3553 103.746 41.369C103.746 39.3827 102.135 37.7725 100.149 37.7725Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14069_18819",
    x: 27.0172,
    y: 61.1347,
    width: 127.089,
    height: 149.866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.00002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.00002
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14069_18819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14069_18819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14069_18819",
    x: 27.0166,
    y: -0.0000665188,
    width: 127.089,
    height: 59.9532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.00002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.00002
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14069_18819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14069_18819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14069_18819",
    x1: 90.5594,
    y1: 18.5859,
    x2: 90.5594,
    y2: 198.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTransaction);
export default __webpack_public_path__ + "static/media/emptyTransaction.d4275147d6a4b5bccab6da9680a19c32.svg";
export { ForwardRef as ReactComponent };